export async function requestPermissions(client,permissions){return client.request({method:"wallet_requestPermissions",params:[permissions]},{retryCount:0})}